import React, { useState } from "react";
import Calendar from "react-calendar"; // Simple calendar
import "react-calendar/dist/Calendar.css"; // Default styles for react-calendar
import "../css/css_pages/Service.css"; // Custom CSS

const ServiceOperations = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [tasks, setTasks] = useState({});
  const [filter, setFilter] = useState("all"); // Filter state: today, week, month, year, or all
  const [formVisible, setFormVisible] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    time: "",
    client: "",
  });

  const clients = ["Client A", "Client B", "Client C"]; // Predefined list of clients

  // Filter tasks based on the selected filter
  const filterTasks = () => {
    const now = new Date();
    const filteredTasks = {};

    // Get start of the current week, month, and year for comparison
    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - now.getDay()); // Set to the start of the week (Sunday)

    // const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1); // Start of the month

    // const startOfYear = new Date(now.getFullYear(), 0, 1); // Start of the year

    Object.entries(tasks).forEach(([date, taskList]) => {
      const taskDate = new Date(date);

      // Filter tasks based on selected filter
      if (
        (filter === "today" && taskDate.toDateString() === now.toDateString()) ||
        (filter === "week" && taskDate >= startOfWeek && taskDate < startOfWeek.setDate(startOfWeek.getDate() + 7)) ||
        (filter === "month" && taskDate.getMonth() === now.getMonth() && taskDate.getFullYear() === now.getFullYear()) ||
        (filter === "year" && taskDate.getFullYear() === now.getFullYear()) ||
        filter === "all"
      ) {
        filteredTasks[date] = taskList;
      }
    });

    return filteredTasks;
  };

  const handleDateClick = (date) => {
    setSelectedDate(date);
    setFormVisible(true);
    setFormData({ title: "", description: "", time: "", client: "" }); // Reset form
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const dateKey = selectedDate.toDateString();
    setTasks((prevTasks) => ({
      ...prevTasks,
      [dateKey]: [
        ...(prevTasks[dateKey] || []),
        {
          title: formData.title,
          description: formData.description,
          time: formData.time,
          client: formData.client,
        },
      ],
    }));

    setFormVisible(false);
  };

  const closeForm = () => {
    setFormVisible(false);
  };

  const filteredTasks = filterTasks();

  return (
    <div className="main-content service-operations-page">
      <h1>Service Operations</h1>

      {/* Calendar */}
      <div className="calendar-container">
        <Calendar
          onClickDay={handleDateClick}
          value={selectedDate}
          className="big-calendar"
        />
      </div>

      {/* Filter Options */}
      <div className="task-filters">
        <button onClick={() => setFilter("today")}>Today</button>
        <button onClick={() => setFilter("week")}>This Week</button>
        <button onClick={() => setFilter("month")}>This Month</button>
        <button onClick={() => setFilter("year")}>This Year</button>
        <button onClick={() => setFilter("all")}>All Tasks</button>
      </div>

      {/* Task List */}
      <div className="task-list">
        <h2>Tasks</h2>
        {Object.keys(filteredTasks).length === 0 ? (
          <p>No tasks found for the selected filter.</p>
        ) : (
          Object.entries(filteredTasks).map(([date, taskList]) => (
            <div key={date} className="task-date-section">
              <h3>{date}</h3>
              <ul>
                {taskList.map((task, index) => (
                  <li key={index}>
                    <strong>{task.time} - {task.title}:</strong> {task.description} (Client: {task.client})
                  </li>
                ))}
              </ul>
            </div>
          ))
        )}
      </div>

      {/* Task Form Modal */}
      {formVisible && (
        <div className="task-form-modal">
          <div className="form-content">
            <div className="close-icon" onClick={closeForm}>
              &times;
            </div>
            <h2>Schedule Task for {selectedDate.toDateString()}</h2>
            <form onSubmit={handleFormSubmit}>
              <div>
                <label>Task Title:</label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleFormChange}
                  required
                />
              </div>
              <div>
                <label>Description:</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleFormChange}
                  required
                />
              </div>
              <div>
                <label>Time:</label>
                <input
                  type="time"
                  name="time"
                  value={formData.time}
                  onChange={handleFormChange}
                  required
                />
              </div>
              <div>
                <label>Client:</label>
                <select
                  name="client"
                  value={formData.client}
                  onChange={handleFormChange}
                  required
                >
                  <option value="">Select a Client</option>
                  {clients.map((client, index) => (
                    <option key={index} value={client}>
                      {client}
                    </option>
                  ))}
                </select>
              </div>
              <button type="submit">Save Task</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceOperations;
